module.exports = __webpack_public_path__ + "static/media/message-icon.3af32f82.svg";